import { OptionsDatasource } from '@genesislcap/foundation-ui';
import { mapStateToControlProps, or, rankWith } from '@jsonforms/core';
import { html } from '@microsoft/fast-element';
import { optionIs } from '../testers/optionIs';
import { SELECT_CONTROL_RANK } from './RenderersRanks';
OptionsDatasource;
export const ConnectedSelectControlRendererTemplate = (prefix = 'zero') => html `
  <template>
    <control-wrapper
      :control=${(x) => x.control}
      :touched=${(x) => x.touched}
      ?submitted=${(x) => x.submitted}
    >
      <${prefix}-combobox
        style="width: 100%"
        async=${(x) => { var _a; return (_a = x.control.uischema.options) === null || _a === void 0 ? void 0 : _a.async; }}
        placeholder=${(x) => x.control.uischema.placeholder || x.control.label}
        ?disabled=${(x) => !x.control.enabled}
        @value-change=${(x, c) => {
    var _a;
    const value = (_a = c.event.detail) === null || _a === void 0 ? void 0 : _a.value;
    x.control.handleChange(x.control.path, value);
    x.onBlur();
}}
        id=${(x) => x.control.path}
        data-test-id=${(x) => x.control.path}
      >
        <options-datasource
          resourceName=${(x) => { var _a; return (_a = x.control.uischema.options) === null || _a === void 0 ? void 0 : _a.allOptionsResourceName; }}
          value-field=${(x) => { var _a; return (_a = x.control.uischema.options) === null || _a === void 0 ? void 0 : _a.valueField; }}
          label-field=${(x) => { var _a; return (_a = x.control.uischema.options) === null || _a === void 0 ? void 0 : _a.labelField; }}
          option-element="${prefix}-option"
          :datasourceConfig=${(x) => { var _a; return (_a = x.control.uischema.options) === null || _a === void 0 ? void 0 : _a.datasourceConfig; }}
          :data=${(x) => { var _a; return (_a = x.control.uischema.options) === null || _a === void 0 ? void 0 : _a.data; }}
          :initialSelectedValue=${(x) => x.control.data}
        ></options-datasource>
      </${prefix}-combobox>
    </control-wrapper>
  </template>
`;
export const ConnectedSelectControlRendererEntry = {
    renderer: html `
    ${(x) => ConnectedSelectControlRendererTemplate(x.jsonforms.prefix)}
  `,
    tester: rankWith(SELECT_CONTROL_RANK, or(optionIs('allOptionsResourceName'), optionIs('data'))),
    mapper: mapStateToControlProps,
};
